// BUG this works in old but not new
export default String.raw`
$$X(u) = \sum_{n=0}^{N-1} x(n)e^{-i2\pi un/N}$$
$$\int_0^\infty H(\omega)e^{i\omega x} dx$$
`

